
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#faa61a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M16.42 7.95a6.251 6.251 0 11-8.84 0 6.253 6.253 0 018.84 0z"}}),_c('path',{attrs:{"d":"M8.25 21.64a9.89 9.89 0 01-4.91-4.26 9.891 9.891 0 01-1.25-6.25M5.85 4.48a9.952 9.952 0 0112.19-.07M15.75 21.64a9.89 9.89 0 004.91-4.26 9.891 9.891 0 001.25-6.25","opacity":".4"}})])])
          )
        }
      }
    